import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-about">
            <Link to="/" className="footer-logo">
              <img src="/logos/Trimline Group LLC.png" alt="Trimline Group Logo" />
            </Link>
            <p>Trimline Group is a Limited Liability Company registered in Wyoming USA.</p>
          </div>
          
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/subsidiaries">Subsidiaries</Link></li>
              <li><Link to="/trade">International Trade</Link></li>
              <li><Link to="/brands">E-Commerce & Brands</Link></li>
              <li><Link to="/tech">Tech</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          
          <div className="footer-links">
            <h4>Contact Info</h4>
            <ul>
              <li><i className="fas fa-map-marker-alt"></i> Trimline International LLC, WY 82801 USA</li>
              <li><i className="fas fa-phone-alt"></i> +1-646-980-4849</li>
              <li><i className="fas fa-envelope"></i><a href="mailto:info@trimlineco.com"> info@trimlineco.com</a></li>
            </ul>
          </div>
        </div>
        
        <div className="copyright">
          <p>&copy; 2025 Trimline Group LLC. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;